<template>
  <div class="side-menu">
    <div class="logo">
      <router-link to="/"
        ><v-img src="@/assets/logo-adata.svg" width="120px" height="40px"
      /></router-link>
    </div>
    <div class="navigation overflow-y-scroll hide-native-scrollbar">
      <!-- About us -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/aboutus') }"
        >
          <router-link
            :to="{ path: '/aboutus', query: { section: 0 } }"
            class="h5 w-100"
          >
            <v-icon>business</v-icon>
            <span class="navigation-item__head__name h5">About us</span>
          </router-link>
        </div>
      </div>
      <!-- Page Management -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: isPageManagementActive }"
          @click="isPageManagementOpen = !isPageManagementOpen"
        >
          <v-icon>description</v-icon>
          <span class="navigation-item__head__name h5">Page Management</span>
          <v-spacer></v-spacer>
          <v-icon v-if="isPageManagementOpen">arrow_drop_up</v-icon>
          <v-icon v-else>arrow_drop_down</v-icon>
        </div>
        <div class="navigation-item__sub" v-if="isPageManagementOpen">
          <router-link
            class="navigation-item__sub__item"
            :to="{ name: 'HomePage', query: { section: 0 } }" >
            Home Page
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ name: 'Navigation', query: { section: 0 } }"
          >
            Navigation
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ name: 'BUPage' }"
          >
            BU Page
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/csr-page', query: { section: 0 } }"
          >
            ESG Page
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/career-page', query: { section: 0 } }"
          >
            Career Page
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/contact-worldwide-offices-list' }"
          >
            Contact Page
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/sports-lottery' }"
            v-if="false"
          >
            Sports Lottery Page
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/alert-info' }"
            v-if="false"
            >AlertInfo</router-link
          >
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/privacy' }"
            v-if="false"
            >Privacy</router-link
          >
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/term-of-use' }"
            v-if="false"
            >Term of Use</router-link
          >
        </div>
      </div>
      <!-- Quiktips -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/quiktips') }"
        >
          <router-link :to="{ path: '/quiktips' }" class="h5 w-100">
            <v-icon>stars</v-icon>
            <span class="navigation-item__head__name h5">應用場景</span>
          </router-link>
        </div>
      </div>
      <!-- Product Management -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: isProductManagementActive }"
          @click="isProductManagementOpen = !isProductManagementOpen"
        >
          <v-icon>local_mall</v-icon>
          <span class="navigation-item__head__name h5">Product Management</span>
          <v-spacer></v-spacer>
          <v-icon v-if="isProductManagementOpen">arrow_drop_up</v-icon>
          <v-icon v-else>arrow_drop_down</v-icon>
        </div>
        <div class="navigation-item__sub" v-if="isProductManagementOpen">
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/category' }"
          >
            Category
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/sub-categories' }"
          >
            Sub-categories
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/products' }"
          >
            Product
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/product-download' }"
          >
            Product Download
          </router-link>
        </div>
      </div>
      <!-- Awards -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/awards') }"
        >
          <router-link :to="{ path: '/awards' }" class="h5 w-100">
            <v-icon>stars</v-icon>
            <span class="navigation-item__head__name h5">Awards</span>
          </router-link>
        </div>
      </div>
      <!-- NewsCenter -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/news-center') }"
        >
          <router-link :to="{ path: '/news-center' }" class="h5 w-100">
            <v-icon>cast_connected</v-icon>
            <span class="navigation-item__head__name h5">NewsCenter</span>
          </router-link>
        </div>
      </div>
      <!-- Customer Management -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: isCustomerManagementActive }"
          @click="isCustomerManagementOpen = !isCustomerManagementOpen"
        >
          <v-icon>supervisor_account</v-icon>
          <span class="navigation-item__head__name h5"
            >Customer Management</span
          >
          <v-spacer></v-spacer>
          <v-icon v-if="isCustomerManagementOpen">arrow_drop_up</v-icon>
          <v-icon v-else>arrow_drop_down</v-icon>
        </div>
        <div class="navigation-item__sub" v-if="isCustomerManagementOpen">
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/adata-members' }"
          >
            ADATA Member
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/edm-subscribers' }"
            v-if="false"
          >
            EDM Subscriber
          </router-link>
        </div>
      </div>
      <!-- Service & Support -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/support-page') }"
        >
          <router-link :to="{ path: '/support-page' }" class="h5 w-100">
            <v-icon>live_help</v-icon>
            <span class="navigation-item__head__name h5"
              >Service & Support</span
            >
          </router-link>
        </div>
      </div>
      <!-- Where to buy -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/where-to-buy') }"
        >
          <router-link :to="{ path: '/where-to-buy' }" class="h5 w-100">
            <v-icon>store_mall_directory</v-icon>
            <span class="navigation-item__head__name h5">Where to buy</span>
          </router-link>
        </div>
      </div>
<!-- Support Faqs -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/support-faq') }"
        >
          <router-link :to="{ path: '/support-faq' }" class="h5 w-100">
            <v-icon>stars</v-icon>
            <span class="navigation-item__head__name h5">Support Faq</span>
          </router-link>
        </div>
      </div>
      <!-- Support Warranty -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/support-warranty-policy') }"
        >
          <router-link :to="{ path: '/support-warranty-policy' }" class="h5 w-100">
            <v-icon>description</v-icon>
            <span class="navigation-item__head__name h5">Support Warranty Policy</span>
          </router-link>
        </div>
      </div>
      <!-- Investor Relations -->
      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: isInvestorRelationsActive }"
          @click="isInvestorRelationsOpen = !isInvestorRelationsOpen"
        >
          <v-icon>monetization_on</v-icon>
          <span class="navigation-item__head__name h5">Investor Relations</span>
          <v-spacer></v-spacer>
          <v-icon v-if="isInvestorRelationsOpen">arrow_drop_up</v-icon>
          <v-icon v-else>arrow_drop_down</v-icon>
        </div>
        <div class="navigation-item__sub" v-if="isInvestorRelationsOpen">
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/investor-relations' }"
            @click="$route.query.sections = 0"
          >
            IR Page
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/investor-faq' }"
          >
            Investor FAQ
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/latest-events' }"
          >
            Latest Events
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/shareholder-meeting' }"
          >
            Shareholder Meeting
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/dividend-history' }"
          >
            Dividend History
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/email-alerts' }"
          >
            Email Alerts
          </router-link>
        </div>
      </div>

      <!-- Human Resource -->
      <div class="navigation-item" v-if="false">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/human-resource') }"
        >
          <router-link :to="{ path: '/human-resource' }" class="h5 w-100">
            <v-icon>folder_shared</v-icon>
            <span class="navigation-item__head__name h5">Human Resource</span>
          </router-link>
        </div>
      </div>

      <!-- eNewsletter -->
      <div class="navigation-item" v-if="false">
        <div
          class="navigation-item__head"
          :class="{ active: isENewsletterActive }"
          @click="isENewsletterOpen = !isENewsletterOpen"
        >
          <v-icon>cast</v-icon>
          <span class="navigation-item__head__name h5">eNewsletter</span>
          <v-spacer></v-spacer>
          <v-icon v-if="isENewsletterOpen">arrow_drop_up</v-icon>
          <v-icon v-else>arrow_drop_down</v-icon>
        </div>
        <div class="navigation-item__sub" v-if="isENewsletterOpen">
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/edm-send-list' }"
          >
            EDM Send List
          </router-link>
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/edm-report' }"
          >
            EDM Report
          </router-link>
        </div>
      </div>

      <div class="navigation-item">
        <div
          class="navigation-item__head"
          :class="{ active: $route.fullPath.includes('/material-gallery') }"
        >
          <router-link :to="{ path: '/material-gallery' }" class="h5 w-100">
            <v-icon>insert_photo</v-icon>
            <span class="navigation-item__head__name h5">Material Gallery</span>
          </router-link>
        </div>
      </div>

      <!-- Account Management-->
      <div class="navigation-item" v-if="false">
        <div
          class="navigation-item__head"
          :class="{ active: isAccountManagementActive }"
          @click="isAccountManagementOpen = !isAccountManagementOpen"
        >
          <v-icon>settings</v-icon>
          <span class="navigation-item__head__name h5">Account Management</span>
          <v-spacer></v-spacer>
          <v-icon v-if="isAccountManagementOpen">arrow_drop_up</v-icon>
          <v-icon v-else>arrow_drop_down</v-icon>
        </div>
        <div class="navigation-item__sub" v-if="isAccountManagementOpen">
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/account-list' }"
            >Account List</router-link
          >
          <router-link
            class="navigation-item__sub__item"
            :to="{ path: '/account-log' }"
            >Account Log</router-link
          >
        </div>
      </div>
    </div>
    <div class="navigation-footer">
      <div class="left">
        <div class="square square-1"></div>
        <div class="square square-2"></div>
        <div class="square square-3"></div>
      </div>
      <div class="right">
        <div class="square square-4"></div>
        <div class="square square-5"></div>
        <div class="square square-6">
          <div class="square square-8"></div>
        </div>
        <div class="square square-7">
          <div class="square square-9"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    // is folder subpage active
    isPageManagementActive: false,
    isProductManagementActive: false,
    isCustomerManagementActive: false,
    isInvestorRelationsActive: false,
    isENewsletterActive: false,
    isAccountManagementActive: false,
    // is folder opend
    isPageManagementOpen: false,
    isProductManagementOpen: false,
    isCustomerManagementOpen: false,
    isInvestorRelationsOpen: false,
    isENewsletterOpen: false,
    isAccountManagementOpen: false,
    // forder sub page
    routesOfPageManagement: [
      'home-page',
      'navigation',
      'bupage',
      'csr-page',
      'carrer-page',
      'contact-worldwide-offices-list',
      'sports-lottery-page',
      'alert-info',
      'privacy',
      'term-of-use',
    ],
    routesOfProductManagement: [
      'category',
      'sub-categories',
      'products',
      'product-download',
    ],
    routesOfCustomerManagement: ['adata-members', 'edm-subscribers'],
    routesOfInvestorRelations: [
      'investor-relations',
      'investor-faq',
      'latest-events',
      'shareholder-meeting',
      'dividend-history',
      'email-alerts',
    ],
    routesOfENewsletter: ['edm-send-list', 'edm-report'],
    routesOfAccountManagement: ['account-list', 'account-log'],
  }),
  computed: {
    currentRoute() {
      return this.$route.fullPath;
    },
  },
  methods: {
    checkPageManagementActive() {
      this.isPageManagementActive = this.routesOfPageManagement.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkProductManagementActive() {
      this.isProductManagementActive = this.routesOfProductManagement.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkCustomerManagementActive() {
      this.isCustomerManagementActive = this.routesOfCustomerManagement.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkInvestorRelationsActive() {
      this.isInvestorRelationsActive = this.routesOfInvestorRelations.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkEnewsletterActive() {
      this.isENewsletterActive = this.routesOfENewsletter.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
    checkAccountManagementActive() {
      this.isAccountManagementActive = this.routesOfAccountManagement.includes(
        this.$route.matched[0].path.substring(1),
      );
    },
  },
  watch: {
    currentRoute() {
      // console.log('from', from);
      // console.log('to', to);
      // console.log(to);
      // console.log('sub', this.$route.matched[0].path.substring(1));
      // console.log('active', this.isPageManagementActive);

      this.checkPageManagementActive();
      this.checkProductManagementActive();
      this.checkCustomerManagementActive();
      this.checkInvestorRelationsActive();
      this.checkEnewsletterActive();
      this.checkAccountManagementActive();
    },
  },
  mounted() {
    this.checkPageManagementActive();
    this.checkProductManagementActive();
    this.checkCustomerManagementActive();
    this.checkInvestorRelationsActive();
    this.checkEnewsletterActive();
    this.checkAccountManagementActive();
  },
};
</script>

<style lang="scss" scoped>
// hide scroll bar, maybe used on navigation
.hide-native-scrollbar {
  scrollbar-width: none; /* Firefox 64 */
  -ms-overflow-style: none; /* Internet Explorer 11 */
  &::-webkit-scrollbar {
    display: none; /** WebKit */
  }
}
.overflow-y-scroll {
  overflow-y: hidden;
  &:hover {
    overflow-y: scroll;
  }
}

.side-menu {
  position: fixed;
  width: 240px;
  height: 100vh;
  background-color: $brand-800;

  a {
    text-decoration: none;
    i {
      text-decoration: none;
    }
  }

  .logo {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 60px;
    width: 240px;
    height: 50px;
    background-color: #f7fafc;
  }
}
.navigation {
  height: calc(100vh - 50px - 91px);
  padding-top: 20px;
  padding-bottom: 26px;

  &-item {
    &__head {
      display: flex;
      padding: 8px 8px;
      i:first-of-type {
        margin-left: 4px;
        margin-right: 12px;
        color: #b8cdfb;
        font-size: 20px;
      }
      i:not(:first-of-type) {
        margin-left: 4px;
        margin-right: 4px;
        color: #b8cdfb;
        font-size: 20px;
      }
      &__name {
        color: #b8cdfb;
      }
      &:hover,
      &:active,
      &:focus,
      &.hover,
      &.active,
      &.focus {
        font-weight: bold;
        cursor: pointer;
        i {
          color: #ffffff;
        }
        span {
          color: #ffffff;
        }
      }
    }
    &__sub {
      margin-left: 38px;
      &__item {
        display: block;
        height: 36px;
        padding: 8px;
        color: #b8cdfb;
        font-size: 14px;
        a {
          color: #b8cdfb;
        }
        &:hover,
        &.hover {
          font-weight: bold;
          cursor: pointer;
        }
        &:active,
        &.active,
        &.router-link-active,
        .router-link-active {
          font-weight: bold;
          color: white;
          cursor: pointer;
        }
      }
    }
  }
}
.navigation-footer {
  display: flex;
  position: absolute;
  bottom: 0;
  width: 240px;
  height: 91px;

  .square {
    position: absolute;
  }

  .left {
    position: relative;
    margin-top: 27px;
    width: 98px;
    height: 65px;

    .square-1 {
      left: 0;
      width: 27px;
      height: 65px;
      background-color: #88c640;
    }
    .square-2 {
      right: 0px;
      width: 71px;
      height: 25px;
      background-color: #1dafec;
    }
    .square-3 {
      bottom: 0;
      right: 0;
      width: 71px;
      height: 40px;
      background-color: #a3ffd8;
    }
  }
  .right {
    position: relative;
    width: 142px;
    height: 91px;

    .square-4 {
      top: 0;
      left: 0;
      width: 102px;
      height: 51px;
      background-color: #0184f6;
    }
    .square-5 {
      top: 0;
      right: 0;
      width: 40px;
      height: 51px;
      background-color: #1e4292;
    }

    .square-6 {
      bottom: 0;
      left: 0;
      width: 102px;
      height: 40px;
      background-color: #feda4d;
    }

    .square-7 {
      bottom: 0;
      right: 0;
      width: 40px;
      height: 40px;
      background-color: #fd882f;
    }

    .square-8 {
      $radius: 40px;
      bottom: 0;
      right: 0;
      width: $radius;
      height: $radius;
      background-color: #feeba0;
      border-radius: $radius * 2 0 0 0;
    }

    .square-9 {
      $radius: 40px;
      top: 0;
      right: 0;
      width: $radius;
      height: $radius;
      background-color: #fdc090;
      border-radius: 0 $radius * 2 0 0;
    }
  }
}
</style>
